export default __webpack_public_path__ + "static/media/ic_error_red.0271fc43.svg";